import { API } from '../global/global';

export interface Usuario {
  id: number;
  nombre: string;
  apellido_paterno: string;
  apellido_materno?: string;
  correo: string;
  rol_id: number;
  plataforma_id: number;
  estatus: number;
  created_at: string;
  updated_at: string;
  rol: {
    id: number;
    nombre: string;
    descripcion: string;
  };
  plataforma: {
    id: number;
    nombre: string;
    slug: string;
  };
}

export interface CreateUsuarioRequest {
  nombre: string;
  apellido_paterno: string;
  apellido_materno?: string;
  correo: string;
  contrasena: string;
  rol_id: number;
  plataforma_id: number;
}

export interface UpdateUsuarioRequest {
  nombre: string;
  apellido_paterno: string;
  apellido_materno?: string;
  correo: string;
  contrasena?: string;
  rol_id: number;
  plataforma_id: number;
}

export interface Rol {
  id: number;
  nombre: string;
  descripcion: string;
}

export interface Plataforma {
  id: number;
  nombre: string;
  slug: string;
}

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Authorization': `Bearer ${token}`
  };
};

export const usuariosApi = {
  getAll: async (): Promise<Usuario[]> => {
    const response = await fetch(`${API}/usuarios`, {
      headers: getAuthHeaders()
    });
    
    if (!response.ok) {
      throw new Error('Error al obtener usuarios');
    }
    
    const data = await response.json();
    return data.data;
  },

  getById: async (id: number): Promise<Usuario> => {
    const response = await fetch(`${API}/usuarios/${id}`, {
      headers: getAuthHeaders()
    });
    
    if (!response.ok) {
      throw new Error('Error al obtener usuario');
    }
    
    const data = await response.json();
    return data.data;
  },

  create: async (usuario: CreateUsuarioRequest): Promise<Usuario> => {
    const response = await fetch(`${API}/usuarios`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(usuario)
    });
    
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Error al crear usuario');
    }
    
    const data = await response.json();
    return data.data;
  },

  update: async (id: number, usuario: UpdateUsuarioRequest): Promise<Usuario> => {
    const response = await fetch(`${API}/usuarios/${id}`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify(usuario)
    });
    
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Error al actualizar usuario');
    }
    
    const data = await response.json();
    return data.data;
  },

  getRoles: async (): Promise<Rol[]> => {
    const response = await fetch(`${API}/usuarios/data/roles`, {
      headers: getAuthHeaders()
    });
    
    if (!response.ok) {
      throw new Error('Error al obtener roles');
    }
    
    const data = await response.json();
    return data.data;
  },

  getPlataformas: async (): Promise<Plataforma[]> => {
    const response = await fetch(`${API}/usuarios/data/plataformas`, {
      headers: getAuthHeaders()
    });
    
    if (!response.ok) {
      throw new Error('Error al obtener plataformas');
    }
    
    const data = await response.json();
    return data.data;
  }
};
